@if (state$ | async; as state) {
  @if (state.isOpen) {
    <div class="tutorial-overlay">
      <div class="tutorial-modal" role="dialog" aria-modal="true" [attr.aria-label]="'TUTORIAL.TITLE' | translate">
        <div class="tutorial-header">
          <h3>{{ state.steps[state.currentStepIndex].titleKey | translate }}</h3>
          <span class="tutorial-step-indicator">
            {{ 'TUTORIAL.STEP_INDICATOR' | translate:{ current: state.currentStepIndex + 1, total: state.steps.length } }}
          </span>
        </div>

        <div class="tutorial-body">
          <div class="tutorial-media">
            @for (step of state.steps; track step.id; let i = $index) {
              @if (i === state.currentStepIndex) {
                <img
                  [src]="step.gifPath"
                  [alt]="step.titleKey | translate"
                  loading="eager"
                  decoding="async"
                  (error)="onGifError($event)"
                />
              }
            }
          </div>
          <div class="tutorial-info">
            <p>{{ state.steps[state.currentStepIndex].contentKey | translate }}</p>
            <p class="tutorial-hint">
              {{ state.steps[state.currentStepIndex].hintKey | translate }}
            </p>
          </div>
        </div>

        <div class="tutorial-actions">
          <button type="button" class="btn btn-secondary" (click)="onSkip()">
            {{ 'BUTTON.SKIP' | translate }}
          </button>

          <div class="step-navigation">
            <button type="button" class="btn btn-secondary" (click)="onBack()" [disabled]="state.currentStepIndex === 0">
              {{ 'BUTTON.BACK' | translate }}
            </button>

            @if (state.currentStepIndex < state.steps.length - 1) {
              <button type="button" class="btn btn-primary" (click)="onNext()">
                {{ 'BUTTON.NEXT' | translate }}
              </button>
            } @else {
              <button type="button" class="btn btn-primary" (click)="onFinish()">
                {{ 'BUTTON.FINISH' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  }
}
